const itemTypeToEmoji = {
    'COMMON_LETTER_A': {emoji: 'A', translation: 'Letter A'},
    'COMMON_LETTER_B': {emoji: 'B', translation: 'Letter B'},
    'COMMON_LETTER_C': {emoji: 'C', translation: 'Letter C'},
    'COMMON_LETTER_D': {emoji: 'D', translation: 'Letter D'},
    'COMMON_LETTER_E': {emoji: 'E', translation: 'Letter E'},
    'COMMON_LETTER_F': {emoji: 'F', translation: 'Letter F'},
    'COMMON_LETTER_G': {emoji: 'G', translation: 'Letter G'},
    'COMMON_LETTER_H': {emoji: 'H', translation: 'Letter H'},
    'COMMON_LETTER_I': {emoji: 'I', translation: 'Letter I'},
    'COMMON_LETTER_J': {emoji: 'J', translation: 'Letter J'},
    'COMMON_LETTER_K': {emoji: 'K', translation: 'Letter K'},
    'COMMON_LETTER_L': {emoji: 'L', translation: 'Letter L'},
    'COMMON_LETTER_M': {emoji: 'M', translation: 'Letter M'},
    'COMMON_LETTER_N': {emoji: 'N', translation: 'Letter N'},
    'COMMON_LETTER_O': {emoji: 'O', translation: 'Letter O'},
    'COMMON_LETTER_P': {emoji: 'P', translation: 'Letter P'},
    'COMMON_LETTER_Q': {emoji: 'Q', translation: 'Letter Q'},
    'COMMON_LETTER_R': {emoji: 'R', translation: 'Letter R'},
    'COMMON_LETTER_S': {emoji: 'S', translation: 'Letter S'},
    'COMMON_LETTER_T': {emoji: 'T', translation: 'Letter T'},
    'COMMON_LETTER_U': {emoji: 'U', translation: 'Letter U'},
    'COMMON_LETTER_V': {emoji: 'V', translation: 'Letter V'},
    'COMMON_LETTER_W': {emoji: 'W', translation: 'Letter W'},
    'COMMON_LETTER_X': {emoji: 'X', translation: 'Letter X'},
    'COMMON_LETTER_Y': {emoji: 'Y', translation: 'Letter Y'},
    'COMMON_LETTER_Z': {emoji: 'Z', translation: 'Letter Z'},

    'UNCOMMON_EMOJI_SMILING_FACE': {emoji: '🙂', translation: 'Smile Emoji'},
    'UNCOMMON_EMOJI_SAD_FACE': {emoji: '🙁', translation: 'Sad Emoji'},
    'UNCOMMON_EMOJI_GRINNING_FACE': {emoji: '😀', translation: 'Grin Emoji'},
    'UNCOMMON_EMOJI_ROLLING_ON_THE_FLOOR_LAUGHING': {emoji: '🤣', translation: 'Rofl Emoji'},
    'UNCOMMON_EMOJI_LOUDLY_CRYING': {emoji: '😭', translation: 'Cry Emoji'},
    'UNCOMMON_EMOJI_PARTYING_FACE': {emoji: '🥳', translation: 'Party Emoji'},
    'UNCOMMON_EMOJI_UPSIDE_DOWN_FACE': {emoji: '🙃', translation: 'Reverse Face Emoji'},
    'UNCOMMON_EMOJI_HOLDING_BACK_TEARS': {emoji: '🥹', translation: 'Please Emoji'},
    'UNCOMMON_EMOJI_TRIUMPHANT_FACE': {emoji: '😤', translation: 'Triumphant Emoji'},
    'UNCOMMON_EMOJI_THINKING_FACE': {emoji: '🤔', translation: 'Thinking Emoji'},
    'UNCOMMON_EMOJI_FACE_WITHOUT_MOUTH': {emoji: '😶', translation: 'Mouthless Emoji'},
    'UNCOMMON_EMOJI_DISGUISED_FACE': {emoji: '🥸', translation: 'Anonymous Emoji'},
    'UNCOMMON_EMOJI_CHECK_MARK': {emoji: '✔️', translation: 'Checkmark Emoji'},
    'UNCOMMON_EMOJI_CROSS_MARK': {emoji: '❌', translation: 'Cross Emoji'},
    'UNCOMMON_EMOJI_HEART': {emoji: '❤️', translation: 'Heart Emoji'},
    'UNCOMMON_EMOJI_HUNDRED': {emoji: '💯', translation: 'Hundred Emoji'},
    'UNCOMMON_EMOJI_STAR': {emoji: '🌟', translation: 'Star Emoji'},
    'UNCOMMON_EMOJI_FIRE': {emoji: '🔥', translation: 'Fire Emoji'},
    'UNCOMMON_EMOJI_EYES': {emoji: '👀', translation: 'Eyes Emoji'},
    'UNCOMMON_EMOJI_THUMBS_UP': {emoji: '👍', translation: 'Thumbs Up Emoji'},
    'UNCOMMON_EMOJI_THUMBS_DOWN': {emoji: '👎', translation: 'Thumbs Down Emoji'},

    'RARE_EMOJI_MONEY_FACE': {emoji: '🤑', translation: 'Rich Emoji'},
    'RARE_EMOJI_PILE_OF_POO': {emoji: '💩', translation: 'Poo Emoji'},
    'RARE_EMOJI_PERSON_GESTURING_NO': {emoji: '️🙅', translation: 'Deny Emoji'},
    'RARE_EMOJI_ROCKET': {emoji: '🚀', translation: 'Rocket Emoji'},
    'RARE_EMOJI_NAIL_POLISH': {emoji: '💅', translation: 'Nail Emoji'},
    'RARE_EMOJI_SUNGLASSES': {emoji: '😎', translation: 'Sunglasses Emoji'},
    'RARE_EMOJI_MECHANICAL_ARM': {emoji: '🦾', translation: 'Iron Flex Emoji'},

    'EPIC_EMOJI_FLEXED_BICEPS': {emoji: '💪', translation: 'Flex Emoji'},
    'EPIC_EMOJI_ROCK_GESTURE': {emoji: '🤟', translation: 'Rock Emoji'},
    'EPIC_EMOJI_PINCHED_FINGERS': {emoji: '🤌', translation: 'Perfect Emoji'},
    'EPIC_EMOJI_OK_HAND': {emoji: '👌', translation: 'Nice Emoji'},
    'EPIC_EMOJI_EGGPLANT': {emoji: '🍆', translation: 'Eggplant Emoji'},

    'ELUSIVE_EMOJI_SHEEP': {emoji: '🐑', translation: 'Super Sheep Emoji'},
    'ELUSIVE_EMOJI_CROWN': {emoji: '👑', translation: 'Super Crown Emoji'},
    'ELUSIVE_EMOJI_MONEY_BAG': {emoji: '💰', translation: 'Super Rich Emoji'},

    getEmojis: function (types) {
        return types.map(type => this[type]?.emoji);
    },
    getTranslations: function (types) {
        return types.map(type => this[type]?.translation);
    },
    getRarity: function (type) {
        if (type.startsWith('COMMON_LETTER')) {
            return 'LETTER';
        } else if (type.startsWith('UNCOMMON')) {
            return 'UNCOMMON';
        } else if (type.startsWith('RARE')) {
            return 'RARE';
        } else if (type.startsWith('EPIC')) {
            return 'EPIC';
        } else if (type.startsWith('ELUSIVE')) {
            return 'ELUSIVE';
        }
    },
    getRarityFromNumber: function (number) {
        switch (number) {
            case 1:
                return 'LETTER';
            case 2:
                return 'COMMON';
            case 3:
                return 'UNCOMMON';
            case 4:
                return 'RARE';
            default:
                return 'ELUSIVE';
        }
    },
    getRarityLevel: function (type) {
        if (type.startsWith('COMMON_LETTER')) {
            return 1;
        } else if (type.startsWith('UNCOMMON')) {
            return 2;
        } else if (type.startsWith('RARE')) {
            return 3;
        } else if (type.startsWith('EPIC')) {
            return 4;
        } else if (type.startsWith('ELUSIVE')) {
            return 5;
        }
    },
    getAllEmojis: function () {
        return Object.keys(this)
            .filter(key => !key.startsWith('COMMON_LETTER') && typeof this[key] === 'object')
            .map(key => this[key].emoji);
    },
    getByCharacter: function (emoji) {
        const key = Object.keys(this)
            .find(key => this[key].emoji && this[key].emoji.toLowerCase() === emoji);
        return key || null;
    },
    getCountOfRarityLevel: function (rarityLevel) {
        return Object.keys(this)
            .filter(key => typeof this[key] === 'object') // ensure we only get emoji entries
            .reduce((count, key) =>
                this.getRarityLevel(key) === rarityLevel ? count + 1 : count, 0
            );
    }
};

export default itemTypeToEmoji;
